var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    stroke: "#510C76",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.883 16.968c0-.772.62-1.398 1.384-1.398h9.096c.765 0 1.384.626 1.384 1.398v5.192c0 .773-.62 1.398-1.384 1.398H8.267a1.391 1.391 0 0 1-1.384-1.398v-5.192z",
    fill: "#E8DEF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.684 20.071H4.805c-.874 0-1.596-.72-1.45-1.59.749-4.482 4.61-7.895 9.26-7.895 4.652 0 8.513 3.413 9.262 7.895.146.87-.577 1.59-1.45 1.59h-1.879M17.263 5.693c0 2.592-2.08 4.693-4.647 4.693-2.566 0-4.647-2.101-4.647-4.693C7.969 3.1 10.049 1 12.616 1c2.566 0 4.647 2.101 4.647 4.693zM8.167 23.766h9.096c.764 0 1.384-.626 1.384-1.398v-5.192c0-.772-.62-1.398-1.384-1.398H8.167c-.765 0-1.384.626-1.384 1.398v5.192c0 .772.62 1.398 1.384 1.398zm4.943-3.994c0 .33-.265.599-.593.599a.596.596 0 0 1-.593-.6c0-.33.265-.598.593-.598.328 0 .593.268.593.599z",
    stroke: "{stroke}",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/roles.ace8ab615a2f02d35c9b11d9b78fcfc0.svg";
export { ForwardRef as ReactComponent };